/**
 * @fileoverview Resolve one `@puffin-core/error-handling` string: consumer `t` → English default.
 * @module @puffin-core/error-handling/strings/resolveString
 *
 * A translator's return is treated as MISSING, and the English default used, when it is nullish, empty, or THE KEY
 * ECHOED BACK, which is what react-i18next returns for an unregistered key. Bound from the ONE shared implementation in
 * `@puffin-core/i18n-bootstrap/strings-kit`, the React-free subpath: this leaf is imported at app boot by
 * `@puffin-core/i18n-namespaces`, so a barrel import would drag `createAppI18n` into every app's boot chunk.
 */

import { createStringResolver } from '@puffin-core/i18n-bootstrap/strings-kit';

import { ERROR_HANDLING_EN } from './en.js';

/**
 * @param {((key: string, params?: Object) => string|undefined|null)|undefined|null} t - Optional consumer translator.
 * @param {string} key - The string key.
 * @param {Object} [params] - Optional interpolation params forwarded to the consumer's `t`.
 * @returns {string|undefined} The resolved string, or `undefined` for a key the bundle lacks.
 */
export const resolveString = createStringResolver(ERROR_HANDLING_EN);

export default resolveString;
